// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-input-date input::-moz-placeholder{--tw-placeholder-opacity:1;color:#4c4d4f;color:rgba(76,77,79,var(--tw-placeholder-opacity));opacity:1}.app-input-date input::placeholder{--tw-placeholder-opacity:1;color:#4c4d4f;color:rgba(76,77,79,var(--tw-placeholder-opacity));opacity:1}.vd-picker__table-day__current{border:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
